import { tagesschluessel } from '@netcon-work/shared'

/**
 * **„↻ wieder vorgelegt" an einer Zeile der Rangfolge**
 * ([E-357](../../../../../docs/ENTSCHEIDUNGEN.md#e-357), 16.09.2026).
 *
 * Ohne die Marke stünde eine wartende Aufgabe plötzlich ganz vorn, und niemand wüsste, warum.
 * Ruhiger Ton, nicht die Warnfarbe: wer sich etwas wieder vorgelegt hat, ist nicht in Verzug –
 * er wollte heute hineinsehen. Lag der Tag schon zurück, sagt die Marke, seit wann.
 */
export function WiedervorlageMarke({ tag }: { tag: string }) {
  const heute = tagesschluessel(new Date())
  const datum = new Date(`${tag}T12:00:00`).toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
  })
  return (
    <span
      data-wiedervorlage={tag}
      className="shrink-0 rounded-md bg-accent-soft px-[7px] py-[2px] text-[10.5px] font-semibold text-accent-deep"
      title="Du hast sie auf „Wartet auf Antwort“ gelegt und wolltest heute wieder hineinsehen. Starten holt sie zurück in die Arbeit."
    >
      ↻ {tag >= heute ? 'heute wieder vorgelegt' : `wieder vorgelegt seit ${datum}.`}
    </span>
  )
}
